const $doc = $(document);

$doc.on('click', '.js-quantity-control', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $target = $(`[data-id="${$this.data('target-id')}"]`);

  if (!$target.length) {
    return;
  }

  const currentVal = parseInt($target.val()) || 0;
  const min = parseInt($target.attr('min') || 0);
  const max = parseInt($target.attr('max') || 9999);

  if ($this.hasClass('js-quantity-decrease')) {
    $target.val(currentVal <= min ? min : currentVal - 1).trigger('change');
  } else if ($this.hasClass('js-quantity-increase')) {
    $target.val(currentVal >= max ? max : currentVal + 1).trigger('change');
  }
});
